import { SelectModule } from './../common/select/select.module';
import { SacPurposeModule } from './../common/sac-purpose/sac-purpose.module';
import { CaptchaInputModule } from './../common/captcha-input/captcha-input.module';
import { PasswordModule } from './../common/password/password.module';
import { IntlInputModule } from './../common/intl-input/intl-input.module';
import { InputModule } from './../common/input/input.module';
import { SharedModule } from './../shared/shared.module';
import { CardViewModule } from './../common/card-view/card-view.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SacSignupComponent } from './components/sac-signup/sac-signup.component';
import { SacSignupRoutingModule } from './sac-signup-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CaptchaModule } from '../common/captcha/captcha.module';
import { ModuleLoaderModule } from '../common/module-loader/module-loader.module';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SafComponent } from '../core/saf/saf.component';


@NgModule({
  declarations: [SacSignupComponent],
  imports: [
    CommonModule,
    SacSignupRoutingModule,
    CardViewModule,
    SharedModule,
    FormsModule,
    InputModule,
    IntlInputModule,
    ReactiveFormsModule,
    PasswordModule,
    CaptchaInputModule,
    SacPurposeModule,
    CaptchaModule,
    ModuleLoaderModule,
    SelectModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    SafComponent
]
})
export class SacSignupModule { }
